<template>
	<div class="policy-detail">
		<!-- header -->
		<!-- <div class="policy-detail.block">
			<intellectual-header></intellectual-header>
		</div> -->
		<!-- 导航栏 -->
		<div class="policy-detail.block">
			<intellectual-navigation :isTrademark="isTrademark" @toggleTrademarks="toggleTrademarks"></intellectual-navigation>
		</div>
		<div class="+navigation-line"></div>
		<!-- 面包屑 -->
		<div class="policy-detail.bread">
			<Bread :currentPage="{name:'政策解读',path:'/Policy',childName:'政策详情',childPath:$route.path}" />
		</div>
		<div class="policy-detail.container">
			<div class="policy-detail.box">
				<h2>{{policyDetail.name}}<small>来源：知识产权服务平台 时间：{{policyDetail.date_time}}</small></h2>
				<p class="con" v-html="policyDetail.content"></p>
				<!-- <ul>
					<li><a href="">上一篇：知识产权专项资金管理办法修订版</a></li>
					<li><a href="">下一篇：自主创新示范区提升创新能力 优化创新环境支持资金管理办法</a></li>
                </ul> -->

			</div>
		</div>
		<!-- footer -->
		<common-footer></common-footer>
	</div>
</template>

<script>
	import IntellectualHeader from '../components/intellectual-header.vue'
	import IntellectualNavigation from '../components/intellectual-navigation.vue'
	import CommonFooter from "../components/common-footer.vue"
	import Bread from '../components/bread.vue'

	export default {
		components: {
			IntellectualHeader,
			IntellectualNavigation,
			CommonFooter,
			Bread,

		},
		data() {
			return {
                 isTrademark:false,
				 policyDetail:{}
			}
		},
		methods:{
			toggleTrademarks(val){
				this.isTrademark = val
			},
			initPolicyDetail(){
				this.http.get(`IPR_Policy/${this.$route.params.id}`).then(res => {
					console.log(res.data);
					this.policyDetail = res.data;
				})
			}
		},
		mounted(){
			window.scrollTo(0,0);
			this.initPolicyDetail()
		}
	}
</script>

<style lang="scss">
	@include component(policy-detail) {
		@include part(block) {
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;
			width: 100%;
			background: #fff;
		}

		@include part(bread) {
			width: 100%;
			min-width: $minWidth;
			height: 51px;
			background: #fff;
		}

		@include part(container) {
			width: 100%;
			background: #F7F7F7;
			min-width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;

		}

		@include part(box) {
			width: 1200px;
			background: rgba(255, 255, 255, 1);
			box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
			margin: 0 auto;
			margin-top: 21px;
			color: #333333;
			padding: 50px;

			>h2 {
				margin: 0;
				font-size: 24px;
				font-weight: 400;
				border-bottom: 1px solid #F2F2F2;
				padding-bottom: 29px;

				small {
					display: block;
					color: #999999;
					font-size: 16px;
					margin-top: 20px;
				}
			}
			p{
				//text-align: left;
				line-height: 30px;
				text-indent: 20px;
				margin-top: 40px;
				
			}
			.con{
				text-align: left;
				/deep/.ql-align-center{
					text-align: center;
				}
			}
			>ul{
				margin-top: 119px;
				width: 100%;
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				li{
					margin-bottom: 10px;
					a{
						color: #333333;
					}
				}
			}

		}

	}
</style>
